import { FEN_STARTING_POSITION } from '@libs/chess/constants';

import { IGameSettings, IGameSettingsTime } from './types';

const DEFAULT_TIMECONTROL: IGameSettingsTime = {
  timeInitialSec: 10 * 60,
  timeAddSec: 5,
  noTimeControl: false,
};

export const DEFAULT_SETTINGS: IGameSettings = {
  color: 'alternate',
  elo: 1600,
  fenManual: FEN_STARTING_POSITION,
  fenCatalog: FEN_STARTING_POSITION,
  fenMode: 'manual',
  white: DEFAULT_TIMECONTROL,
  black: DEFAULT_TIMECONTROL,
};

export const CATALOG_ELO = 2300;
